import './SystemCard.css';

function SystemCard({ system, isSelected, onSelect }) {
  const handleClick = () => {
    if (!system.disabled) {
      onSelect(system.id);
    }
  };

  return (
    <div
      className={`system-card ${isSelected ? 'system-card--selected' : ''} ${system.disabled ? 'system-card--disabled' : ''}`}
      onClick={handleClick}
    >
      <div className="system-card__header">
        <input
          type="radio"
          name="rag-system"
          checked={isSelected}
          disabled={system.disabled}
          onChange={() => onSelect(system.id)}
          className="system-card__radio"
        />
        <span className="system-card__name">{system.name}</span>
        {system.disabled && system.disabledReason && (
          <span className="system-card__badge">{system.disabledReason}</span>
        )}
      </div>
      <p className="system-card__description">{system.description}</p>
      {system.docs && system.docs.length > 0 && (
        <div className="system-card__docs">
          <p className="system-card__docs-label">참고 문서</p>
          <ul className="system-card__docs-list">
            {system.docs.map((doc, index) => (
              <li key={index}>
                <a
                  href={doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={e => e.stopPropagation()}
                  className="system-card__doc-link"
                >
                  📄 {doc.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default SystemCard;
